import ExcelJS from "exceljs";

export async function UploadBulk(
  fileData, 
  jenis,
  authIdentity = {},
  opsiCabang = [], 
  opsiSumber = [], 
  opsiSubAkun = []) {

  if (!fileData) return { valid: [], invalid: [], total: 0 };

  const workbook = new ExcelJS.Workbook();
  const buffer = await fileData.arrayBuffer();
  await workbook.xlsx.load(buffer);

  const worksheet = workbook.worksheets[0];
  if (!worksheet) return { valid: [], invalid: [], total: 0 };

  const rows = [];

  const headerRow = worksheet.getRow(1);
  const headers = headerRow.values.slice(1); // buang index 0

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;

    const rowObj = {};

    headers.forEach((header, index) => {
      rowObj[header] = row.getCell(index + 1).value ?? "";
    });

    rows.push(rowObj);
  });

  const hasil = ()=>{
    if(String(authIdentity?.kode_cabang || '').trim() === 'C-1') {  
      return validateDataPusat(rows, jenis, opsiCabang, opsiSumber, opsiSubAkun)
    } else {
      return validateData(rows, opsiSumber, opsiSubAkun)
    };
  }
    
  return hasil();
}


function validateData(rows, opsiSumber, opsiSubAkun) {

  const today = new Date();
  const minDate = new Date();
  minDate.setMonth(today.getMonth() - 1);

  let valid = [];
  let invalid = [];
  let total = 0;

  rows.forEach((row, index) => {

    const tanggalObj = parseExcelDate(row["tanggal"]);
    const sumber = String(row["sumber"] || "").trim();
    const akunSub = String(row["akun : subakun"] || "").trim();
    const akun = akunSub.split(" : ")[0];
    const subakun = akunSub.split(" : ")[1];
    const nominal = Number(row["nominal"]);
    const catatan = String(row["catatan"] || "");

    const isValid =
      tanggalObj &&
      tanggalObj >= minDate &&
      tanggalObj <= today &&
      opsiSumber.includes(sumber.trim()) &&
      opsiSubAkun.includes(akunSub.trim()) &&
      !isNaN(nominal) &&
      nominal > 0 &&
      catatan.length <= 100;

    const record = {
      tanggal: tanggalObj,
      sumber,
      akun,
      subakun,
      nominal,
      catatan,
      rowNumber: index + 2
    };

    if (isValid) {
      valid.push(record);
      total += nominal;
    } else {
      invalid.push(record);
    }

  });

  return { valid, invalid, total };
}

function validateDataPusat(rows, jenis, opsiCabang, opsiSumber, opsiSubAkun) {

  const today = new Date();
  const minDate = new Date();
  minDate.setMonth(today.getMonth() - 1);

  let valid = [];
  let invalid = [];
  let total = 0;

  rows.forEach((row, index) => {
    
    const tanggalObj = parseExcelDate(row["tanggal"]);
    const cabang = String(row["cabang"] || "").trim();
    const sumber = String(row["sumber"] || "").trim();
    const akunSub = String(row["akun : subakun"] || "").trim();
    const akun = akunSub.split(" : ")[0];
    const subakun = akunSub.split(" : ")[1];
    const nominal = Number(row["nominal"]) || row["nominal"]?.result || 0;
    const catatan = String(row["catatan"] || "");
    const opsiCab = opsiCabang.map(x=>x.nama_cabang.trim());
    
    const opsiSubAkunPusat =  
    jenis === 'drp' 
    ? [`PUSAT : DROPPING`]
    : jenis === 'kdr'
      ? [`PUSAT : KOREKSI DROPPING`]
      : [...opsiSubAkun];
    

    const isValid =
      tanggalObj &&
      tanggalObj >= minDate &&
      tanggalObj <= today &&

      opsiCab.includes(cabang) &&
      
      opsiSumber.includes(sumber)&&
      
      opsiSubAkunPusat.includes(akunSub) &&
      
      !isNaN(nominal) &&
      nominal > 0 &&
      
      catatan.length <= 100;

    const record = {
      tanggal: tanggalObj,
      cabang : opsiCabang.find(x => x.nama_cabang === cabang)?.kode_cabang,
      sumber,
      akun,
      subakun,
      nominal,
      catatan,
      id: index + 2
    };
    
    if (isValid) {
      valid.push(record);
      total += nominal;
    } else {
      invalid.push(record);
    }

  });
  return { valid, invalid, total };
}

function parseExcelDate(value) {

  if (value instanceof Date) {
    return value
  } else if (typeof value === "number") {
    return new Date(Math.round((value - 25569) * 86400 * 1000));
  } 

  const parsed = new Date(value.result);
  return isNaN(parsed) ? null : parsed;
}
